/* eslint-disable @tencent/i18next/no-literal-string */
import { ISlideModel } from '@src/slide/domain/ui-model/element-modeles/Interface/slide-model.interface';
import { IPresentationModel } from '@src/slide/domain/ui-model/element-modeles/Interface/presentation-model.interface';
import { UnknownColor } from '@src/slide/application/service/slide-rating-and-improve/base/color-base-analyzer.interface';
import {
    AnalyzerResultType,
    IElementNode,
    ITextElementBoxNode,
} from '@src/slide/application/service/slide-rating-and-improve/slide-content-analyzer.interface';
import { TextColorContrastResult } from '@src/slide/application/service/slide-rating-and-improve/color/result/text-color-contrast-result';
import i18n from '@i18next/i18n';
import { ColorBaseAnalyzer } from '@src/slide/application/service/slide-rating-and-improve/base/color-base-analyzer';

/**
 * 颜色使用分析
 */
export class ColorAnalyzer extends ColorBaseAnalyzer {
    /**
     * 文字颜色对比度检测结果
     */
    public textColorContrastResult: TextColorContrastResult;
    private currentSlideIndex: number;

    public constructor() {
        super();
        this.textColorContrastResult = new TextColorContrastResult(
            i18n.t('文字颜色对比度检测'),
            i18n.t('建议文字和背景颜色对比度更大些'),
        );
    }

    public reset() {
        this.textColorContrastResult.reset();
    }

    public resetWithPresentation(presentation: IPresentationModel) {
        super.resetWithPresentation(presentation);
        this.textColorContrastResult.reset();
    }

    public analysisNewSlide(slideModel: ISlideModel, slideIndex: number) {
        this.currentSlideIndex = slideIndex;
        super.analysisSlide(slideModel);
    }

    public analysisElement(elementNode: IElementNode) {
        super.analysisElement(elementNode);
    }

    public analysisTextElementBox(textElementBoxNode: ITextElementBoxNode) {
        super.analysisTextElementBox(textElementBoxNode);
    }

    public onPresentationEnd() {
        this.analysisFinalResult();
    }

    /**
     * 过滤对比度结果，供给排版检查使用
     */
    private analysisFinalResult(): void {
        const results = this.calculateResult();
        results.forEach((resultPromise) => {
            resultPromise.then((result) => {
                const { boxNode, contrast, ratio, textColor, textFontSize, textBack, contrastRule } = result;
                if (textBack.image) {
                    return;
                }
                if (!ratio || !textFontSize || !contrastRule) {
                    // 分析不全的数据不显示
                    return;
                }
                if (contrast < ratio && contrast > 1.1 && textColor !== UnknownColor) {
                    // 对比度在1.1之下就认为几乎看不见，当作这些文字就是无用来理解
                    this.textColorContrastResult.resultType = AnalyzerResultType.ERROR;
                    this.textColorContrastResult.resultInfo.push({
                        boxNode,
                        textColor,
                        textBack,
                        textFontSize,
                        contrastRule,
                        contrast,
                    });
                }
            });
        });
    }
}
